import "./OutputStyle.css";
import "styles/prosemirror-table.css";
import { EditorContent } from "@tiptap/react";
import { useOutputEditor } from "./hooks/use-output-editor";
import { AnimatePresence, motion } from "framer-motion";
import { CommentButton, CommentSidebar } from "./output-viewer.style";
import { Tooltip } from "antd";

import { useCollaborative } from "./hooks/use-collaborative";
import { Modal } from "@mantine/core";
import { useEffect } from "react";
import { useTopic } from "./hooks/use-topics";
import { useSearchParams } from "react-router-dom";

export const OutputViewer = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { inactivityDisc, newComments, isSynced } = useCollaborative();
  const { output, topic, currentOutputText, coverImage } = useTopic();

  const {
    editor,

    containerRef,
    showCommentButton,
    buttonPosition,
    handleNewComment,

    isExporting,
    exportToGoogleDocs
  } = useOutputEditor();

  useEffect(() => {
    for (const nc of newComments) {
      const el = document.querySelector(`[data-comment-card-id="${nc}"]`);
      const pulseClass = "comment-pulse";

      if (!el) return;

      // Remove the class if it's already there to retrigger animation
      el.classList.remove(pulseClass);

      // Add the animation class
      el.classList.add(pulseClass);

      // Optional: remove the class after animation ends
      el.addEventListener(
        "animationend",
        () => {
          el.classList.remove(pulseClass);
        },
        { once: true }
      );
    }
  }, [newComments]);

  useEffect(() => {
    const exportType = searchParams.get("export");

    if (
      !!exportType &&
      topic &&
      output &&
      currentOutputText.length > 0 &&
      coverImage !== undefined &&
      !isExporting
    ) {
      setSearchParams((params) => {
        params.delete("export");
        return params;
      });

      switch (exportType) {
        case "googledocs":
          exportToGoogleDocs();
          break;
        default:
          break;
      }
    }
  }, [
    topic,
    output,
    editor,
    coverImage,
    currentOutputText,
    searchParams,
    isExporting
  ]);

  if (inactivityDisc) {
    return (
      <div>
        <Modal opened={true} onClose={null} centered withCloseButton={false}>
          <div className="text-center">
            Sleep mode...waiting for you to come back.
          </div>
        </Modal>
      </div>
    );
  }

  return (
    <div className="doc-editor output-editor document-style">
      <div className="output-editor-content" ref={containerRef}>
        <div
          className={`sync-indicator ${
            isSynced ? "is-synced" : "is-connecting"
          }`}
          title={isSynced ? "Synced" : "Syncing"}
        ></div>
        <EditorContent editor={editor} />
        <AnimatePresence>
          {showCommentButton && (
            <motion.div
              key="comment-panel"
              initial={{ opacity: 0, x: 10 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 10 }}
              transition={{ duration: 0.2 }}
              style={{
                top: buttonPosition.top - 24,
                right: buttonPosition.right + 48,
                position: "absolute"
              }}
            >
              <CommentSidebar>
                <Tooltip title="Add comment">
                  <CommentButton onClick={handleNewComment}>➕</CommentButton>
                </Tooltip>
              </CommentSidebar>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};
